module.exports = __webpack_public_path__ + "img/tp10.09e41212.png";